import _ from 'lodash';
import { useRef, useEffect } from 'react';

export function useUpdateMonitor( name, props ) {
  if ( ! props && _.isObject( name ) ) { props = name; name = 'unnamed'; }
  const prev = useRef( props );
  useEffect( () => {
    const changed = _.transform( props, ( changes, value, key ) => {
      if ( prev.current[ key ] === value ) return;
      changes[ key ] = [ prev.current[ key ], value ];
    }, {} );
    if ( ! _.isEmpty( changed ) ) {
      // eslint-disable-next-line no-console
      console.log( `[useUpdateMonitor] ${name} props changed:`, changed );
    }
    prev.current = props;
  } );
}
